import Swiper from 'swiper';

const swiperConfig = {
  slidesPerView: 'auto',
  spaceBetween: 16,
  slidesOffsetBefore: 24,
  slidesOffsetAfter: 24,
};

export const navStore = () => ({
  navData: [],
  mobileNavFeaturedData: undefined,
  mobileNavFooterData: undefined,

  init() {
    this.setData();
  },

  setData() {
    const submenus = document.querySelectorAll('.nav-submenu-data');
    this.navData = Array.from(submenus).map((submenu) =>
      JSON.parse(submenu.textContent)
    );

    const mobileNavFeaturedData = document.querySelector(
      '.mobile-nav-featured-data'
    );
    this.mobileNavFeaturedData = JSON.parse(mobileNavFeaturedData.textContent);

    const mobileNavFooterData = document.querySelector(
      '.mobile-nav-footer-data'
    );
    this.mobileNavFooterData = JSON.parse(mobileNavFooterData.textContent);
  },
});

export const navDesktopComponent = () => ({
  selectedSubmenuIdx: null,

  init() {
    this.$watch('selectedSubmenuIdx', (val) => {
      if (val === null) {
        document
          .querySelector('header.page-header')
          .classList.remove('submenu-open');

        this.$dispatch('close-desktop-nav');
      } else if (val >= 0) {
        document
          .querySelector('header.page-header')
          .classList.add('submenu-open');

        this.$dispatch('open-desktop-nav');
      }
    });
  },

  handleTopCategoryClick(idx) {
    /**
     * If in Theme Editor, pin this submenu open
     */
    if (window.Shopify.designMode) {
      if (!this.isDesignPinned) {
        this.selectedSubmenuIdx = idx;
        this.isDesignPinned = true;
      } else if (this.isDesignPinned) {
        // Closing pin
        this.selectedSubmenuIdx = null;
        this.isDesignPinned = false;
      }
    }
  },

  handleTopCategoryMouseenter(idx) {
    if (this.isDesignPinned) {
      return;
    }

    this.selectedSubmenuIdx = idx;
  },

  handleTopCategoryMouseleave() {
    if (this.isDesignPinned) {
      return;
    }

    this.selectedSubmenuIdx = null;
  },
});

export const navMobileComponent = () => ({
  selectedSubmenuIdx: null,

  init() {
    this.$watch('selectedSubmenuIdx', (val) => {
      if (!Number.isNaN(val) && val !== null) {
        const secondTierDialog = this.$root.querySelector('dialog');
        secondTierDialog.showModal();
      }
    });

    this.$watch(
      'submenuFormat',
      (val) =>
        val === 'linklists-and-swiper' && this.initSecondaryFeatureSwiper()
    );
    this.initFirstTierSwiper();
  },

  get selectedSubmenuLinklists() {
    return this.$store.nav.navData[this.selectedSubmenuIdx]?.blocks.filter(
      (block) => block.type === 'link_list'
    );
  },

  get selectedSubmenuCardBlocks() {
    return this.$store.nav.navData[this.selectedSubmenuIdx]?.blocks.filter(
      (block) => block.type === 'image_link' || block.type === 'cta_card_link'
    );
  },

  get selectedSubmenuTitle() {
    return this.$store.nav.navData[this.selectedSubmenuIdx]?.settings
      .nav_top_category_title;
  },

  get mobileNavFeaturedCardBlocks() {
    return this.$store.nav.mobileNavFeaturedData?.blocks;
  },

  get mobileNavFooterLinks() {
    return this.$store.nav.mobileNavFooterData?.blocks[0].links;
  },

  get mobileNavStyles() {
    return this.$store.nav.mobileNavFooterData?.settings || {};
  },

  get submenuFormat() {
    const submenuBlocks =
      this.$store.nav.navData[this.selectedSubmenuIdx]?.blocks;

    if (!submenuBlocks) {
      return undefined;
    }
    if (
      submenuBlocks.every(
        (block) => block.type === 'image_link' || block.type === 'cta_card_link'
      )
    ) {
      return 'thumbnail-only';
    }
    if (
      submenuBlocks.some((block) => block.type === 'link_list') &&
      submenuBlocks.some(
        (block) => block.type === 'image_link' || block.type === 'cta_card_link'
      )
    ) {
      return 'linklists-and-swiper';
    } else {
      return 'linklists-only';
    }
  },

  openMobileNav() {
    this.$el.closest('dialog').showModal();
  },
  openSecondTier(idx) {
    this.selectedSubmenuIdx = idx;
  },

  closeMobileNav() {
    this.$el.closest('dialog').close();
    this.selectedSubmenuIdx = null;
  },

  detect2ndTierClose(e) {
    if (this.$root.contains(e.target)) {
      this.selectedSubmenuIdx = null;
    }
  },

  initFirstTierSwiper() {
    const swiperEl = this.$root.querySelector('.mobile-nav--tier-1 .swiper');

    new Swiper(swiperEl, swiperConfig);
  },

  initSecondaryFeatureSwiper() {
    const swiperEl = this.$root.querySelector('.mobile-nav--tier-2 .swiper');

    new Swiper(swiperEl, swiperConfig);
  },
});
